import { Directive, ElementRef, Input } from '@angular/core';
import { AuthService } from 'src/app/services/common/auth.service';

@Directive({
  selector: '[appCanvasAuthImage]',
  standalone: true,
})
export class CanvasAuthImageDirective {
  @Input() set appCanvasAuthImage(content: any) {
    this.processImages();
  }

  constructor(
    private readonly el: ElementRef,
    private readonly auth: AuthService
  ) {}

  private processImages() {
    const images = this.el.nativeElement.querySelectorAll('img');
    const token = this.auth.getToken();
    const origin = window.location.origin;
    images.forEach((img: HTMLImageElement) => {
      if (!img.src.includes('token=')) {
        const url = new URL(img.src, window.location.origin);
        url.searchParams.set('token', token);
        url.searchParams.set('origin', origin);
        img.src = url.toString();
      }
    });
  }
}
